import loggingService from "@/services/logs/LoggingService"
import { isSSR } from "./Helpers"

export function logError(error, context) {
  loggingService.error(null, error, context)
  if (process.env.NODE_ENV != 'production') {
    console.error(error, context)
  }
}